import React from 'react';
import clsx from 'classnames';
import './index.css';
import Banner from '../Business/components/Banner';
import TweenOne from 'rc-tween-one';
import { usePageTitle } from '../../hooks';

const Write = () => {
  usePageTitle('标准编制');
  const writeList = [
    {
      id: '1',
      name: 'DL/T 2136-2020 电缆牵引警报装置技术条件',
    },
    {
      id: '2',
      name: 'DL/T2134-2022 电力用安全帽动态性能测试装置',
    },
    {
      id: '3',
      name: 'T/ZAS 2002—2022 可调式电缆固定支架技术条件',
    },
    {
      id: '4',
      name: 'DL/T 2713-2023 电力用便携式电动绞磨',
    },
    {
      id: '5',
      name: 'T/EPTC 003.1—2024 居配工程物资验收检测要求 第1部分 开关设备类',
    },
    {
      id: '6',
      name: 'T/CEC 525—2021 电力金具表面耐磨激光强化技术要求',
    },
    {
      id: '7',
      name: 'T/CAMS 127—2023 电缆绝缘层厚度测量仪',
    },
    {
      id: '8',
      name: 'T/CEC 1185.1-2025 电杆用防护装置技术要求 第1部分：警示墩',
    },
    {
      id: '9',
      name: 'T/CSEE 0543-2025 电力作业用纤维增强复合材料空心圆杆 轴向弯曲与工频耐受电压组合试验方法',
    },
    {
      id: '10',
      name: 'T/CEC 790-2023 便携式配变吊装架',
    },
    {
      id: '11',
      name: 'T/CEC 834-2023 棘轮式电缆弯线器技术条件',
    },
    {
      id: '12',
      name: 'T/ZZB 3508-2023 安全帽冲击吸收和耐穿刺性能测试仪',
    },
    {
      id: '13',
      name: 'DL/T2616-2023 电力用个人保安线通用技术条件',
    },
    {
      id: '14',
      name: 'T/CEC 1185.2-2025 电杆用防护装置技术要求 第2部分：拉线护套',
    },
    {
      id: '15',
      name: 'T/CEC 1281-2025 水泥电杆用悬挂式防坠落器具',
    },
    {
      id: '16',
      name: 'T/CSEE 0542-2025 架空导线用混杂纤维增强复合材料实芯细圆棒  卷绕试验方法',
    },
    {
      id: '17',
      name: 'T/CSEE 0541-2025 架空导线用混杂纤维增强复合材料实芯细圆棒  扭转试验方法',
    },
  ];

  return (
    <div className={clsx('write')} style={{ minHeight: window.innerHeight }}>
      {/* 顶部Banner */}
      <Banner />
      {/* 编写内容 */}
      <div className={clsx('write-substance')}>
        <div className={clsx('write-content')}>
          <TweenOne
            className={clsx('write-content-title')}
            animation={{ y: -30, opacity: 0, type: 'from' }}
          >
            标准编制
          </TweenOne>
          <TweenOne
            className={clsx('write-content-desc')}
            animation={{ y: -40, opacity: 0, type: 'from', delay: 100 }}
          >
            深耕行业场景，参与标准编制
          </TweenOne>
          <TweenOne
            className={clsx('write-content-block')}
            animation={{ y: -50, opacity: 0, type: 'from', delay: 100 }}
          >
            {writeList.map((item, index) => (
              <div className={clsx('write-content-block-item')} key={index}>
                {item.name}
              </div>
            ))}
          </TweenOne>
        </div>
      </div>
    </div>
  );
};

export default Write;
